<template>
  <BaseLayout :full-width="true">
    <!-- 系统选择页面骨架屏 -->
    <div class="mx-auto w-full px-3 sm:px-6 lg:px-8">
      <!-- 页面标题区域骨架 -->
      <div class="flex flex-col items-center pb-6 sm:pb-12">
        <!-- 主标题骨架 -->
        <div
          class="h-8 sm:h-10 w-48 sm:w-64 bg-gray-200 rounded-md animate-pulse mb-2 sm:mb-3"
        ></div>
        <!-- 副标题骨架 -->
        <div
          class="h-4 sm:h-5 w-32 sm:w-48 bg-gray-150 rounded-md animate-pulse"
        ></div>
      </div>

      <!-- 系统列表骨架 -->
      <div
        class="grid grid-cols-1 gap-4 sm:gap-6 sm:grid-cols-2 max-w-4xl mx-auto"
      >
        <!-- 系统卡片骨架 1 -->
        <div
          class="group col-span-1 rounded-lg bg-white shadow-sm transition-all duration-200 hover:shadow-md relative overflow-hidden"
        >
          <!-- 装饰性背景 -->
          <div
            class="absolute inset-0 bg-gradient-to-br from-primary-1/50 to-transparent pointer-events-none"
          />

          <!-- 系统信息骨架 -->
          <div
            class="relative flex w-full items-center justify-between space-x-4 p-4 sm:space-x-6 sm:p-6"
          >
            <div class="flex-1 min-w-0">
              <div class="flex items-center space-x-2 sm:space-x-3">
                <!-- 系统标题和状态骨架 -->
                <div class="flex items-center space-x-2 sm:space-x-3">
                  <div
                    class="h-4 sm:h-5 w-20 sm:w-28 bg-gray-200 rounded-md animate-pulse"
                  ></div>
                  <div
                    class="h-4 w-12 sm:w-16 bg-gray-150 rounded-full animate-pulse"
                  ></div>
                </div>
              </div>
              <!-- 系统描述骨架 -->
              <div
                class="mt-1 h-3 sm:h-4 w-32 sm:w-48 bg-gray-150 rounded-md animate-pulse"
              ></div>
            </div>
            <!-- 系统图标骨架 -->
            <div class="h-10 w-10 sm:h-12 sm:w-12 flex-shrink-0">
              <div
                class="h-full w-full bg-gray-200 rounded-lg animate-pulse"
              ></div>
            </div>
          </div>

          <!-- 系统操作区域骨架 -->
          <div
            class="relative mt-1 sm:mt-2 before:absolute before:inset-x-4 sm:before:inset-x-6 before:top-0 before:h-[1px] before:bg-gradient-to-r before:from-transparent before:via-gray-200/70 before:to-transparent"
          >
            <div class="flex w-full">
              <div
                class="relative inline-flex w-full items-center justify-center gap-x-2 sm:gap-x-3 py-3 sm:py-4"
              >
                <!-- 操作图标和文字骨架 -->
                <div
                  class="h-4 w-4 sm:h-5 sm:w-5 bg-gray-150 rounded animate-pulse"
                ></div>
                <div
                  class="h-4 w-12 sm:w-16 bg-gray-150 rounded-md animate-pulse"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <!-- 系统卡片骨架 2 -->
        <div
          class="group col-span-1 rounded-lg bg-white shadow-sm transition-all duration-200 hover:shadow-md relative overflow-hidden"
        >
          <!-- 装饰性背景 -->
          <div
            class="absolute inset-0 bg-gradient-to-br from-primary-1/50 to-transparent pointer-events-none"
          />

          <!-- 系统信息骨架 -->
          <div
            class="relative flex w-full items-center justify-between space-x-4 p-4 sm:space-x-6 sm:p-6"
          >
            <div class="flex-1 min-w-0">
              <div class="flex items-center space-x-2 sm:space-x-3">
                <!-- 系统标题和状态骨架 -->
                <div class="flex items-center space-x-2 sm:space-x-3">
                  <div
                    class="h-4 sm:h-5 w-24 sm:w-32 bg-gray-200 rounded-md animate-pulse"
                  ></div>
                  <div
                    class="h-4 w-12 sm:w-16 bg-gray-150 rounded-full animate-pulse"
                  ></div>
                </div>
              </div>
              <!-- 系统描述骨架 -->
              <div
                class="mt-1 h-3 sm:h-4 w-36 sm:w-52 bg-gray-150 rounded-md animate-pulse"
              ></div>
            </div>
            <!-- 系统图标骨架 -->
            <div class="h-10 w-10 sm:h-12 sm:w-12 flex-shrink-0">
              <div
                class="h-full w-full bg-gray-200 rounded-lg animate-pulse"
              ></div>
            </div>
          </div>

          <!-- 系统操作区域骨架 -->
          <div
            class="relative mt-1 sm:mt-2 before:absolute before:inset-x-4 sm:before:inset-x-6 before:top-0 before:h-[1px] before:bg-gradient-to-r before:from-transparent before:via-gray-200/70 before:to-transparent"
          >
            <div class="flex w-full">
              <div
                class="relative inline-flex w-full items-center justify-center gap-x-2 sm:gap-x-3 py-3 sm:py-4"
              >
                <!-- 操作图标和文字骨架 -->
                <div
                  class="h-4 w-4 sm:h-5 sm:w-5 bg-gray-150 rounded animate-pulse"
                ></div>
                <div
                  class="h-4 w-12 sm:w-16 bg-gray-150 rounded-md animate-pulse"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <!-- 系统卡片骨架 3 -->
        <div
          class="group col-span-1 rounded-lg bg-white shadow-sm transition-all duration-200 hover:shadow-md relative overflow-hidden"
        >
          <!-- 装饰性背景 -->
          <div
            class="absolute inset-0 bg-gradient-to-br from-primary-1/50 to-transparent pointer-events-none"
          />

          <!-- 系统信息骨架 -->
          <div
            class="relative flex w-full items-center justify-between space-x-4 p-4 sm:space-x-6 sm:p-6"
          >
            <div class="flex-1 min-w-0">
              <div class="flex items-center space-x-2 sm:space-x-3">
                <!-- 系统标题和状态骨架 -->
                <div class="flex items-center space-x-2 sm:space-x-3">
                  <div
                    class="h-4 sm:h-5 w-18 sm:w-24 bg-gray-200 rounded-md animate-pulse"
                  ></div>
                  <div
                    class="h-4 w-12 sm:w-16 bg-gray-150 rounded-full animate-pulse"
                  ></div>
                </div>
              </div>
              <!-- 系统描述骨架 -->
              <div
                class="mt-1 h-3 sm:h-4 w-28 sm:w-40 bg-gray-150 rounded-md animate-pulse"
              ></div>
            </div>
            <!-- 系统图标骨架 -->
            <div class="h-10 w-10 sm:h-12 sm:w-12 flex-shrink-0">
              <div
                class="h-full w-full bg-gray-200 rounded-lg animate-pulse"
              ></div>
            </div>
          </div>

          <!-- 系统操作区域骨架 -->
          <div
            class="relative mt-1 sm:mt-2 before:absolute before:inset-x-4 sm:before:inset-x-6 before:top-0 before:h-[1px] before:bg-gradient-to-r before:from-transparent before:via-gray-200/70 before:to-transparent"
          >
            <div class="flex w-full">
              <div
                class="relative inline-flex w-full items-center justify-center gap-x-2 sm:gap-x-3 py-3 sm:py-4"
              >
                <!-- 操作图标和文字骨架 -->
                <div
                  class="h-4 w-4 sm:h-5 sm:w-5 bg-gray-150 rounded animate-pulse"
                ></div>
                <div
                  class="h-4 w-12 sm:w-16 bg-gray-150 rounded-md animate-pulse"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <!-- 系统卡片骨架 4 -->
        <div
          class="group col-span-1 rounded-lg bg-white shadow-sm transition-all duration-200 hover:shadow-md relative overflow-hidden"
        >
          <!-- 装饰性背景 -->
          <div
            class="absolute inset-0 bg-gradient-to-br from-primary-1/50 to-transparent pointer-events-none"
          />

          <!-- 系统信息骨架 -->
          <div
            class="relative flex w-full items-center justify-between space-x-4 p-4 sm:space-x-6 sm:p-6"
          >
            <div class="flex-1 min-w-0">
              <div class="flex items-center space-x-2 sm:space-x-3">
                <!-- 系统标题和状态骨架 -->
                <div class="flex items-center space-x-2 sm:space-x-3">
                  <div
                    class="h-4 sm:h-5 w-22 sm:w-30 bg-gray-200 rounded-md animate-pulse"
                  ></div>
                  <div
                    class="h-4 w-12 sm:w-16 bg-gray-150 rounded-full animate-pulse"
                  ></div>
                </div>
              </div>
              <!-- 系统描述骨架 -->
              <div
                class="mt-1 h-3 sm:h-4 w-34 sm:w-44 bg-gray-150 rounded-md animate-pulse"
              ></div>
            </div>
            <!-- 系统图标骨架 -->
            <div class="h-10 w-10 sm:h-12 sm:w-12 flex-shrink-0">
              <div
                class="h-full w-full bg-gray-200 rounded-lg animate-pulse"
              ></div>
            </div>
          </div>

          <!-- 系统操作区域骨架 -->
          <div
            class="relative mt-1 sm:mt-2 before:absolute before:inset-x-4 sm:before:inset-x-6 before:top-0 before:h-[1px] before:bg-gradient-to-r before:from-transparent before:via-gray-200/70 before:to-transparent"
          >
            <div class="flex w-full">
              <div
                class="relative inline-flex w-full items-center justify-center gap-x-2 sm:gap-x-3 py-3 sm:py-4"
              >
                <!-- 操作图标和文字骨架 -->
                <div
                  class="h-4 w-4 sm:h-5 sm:w-5 bg-gray-150 rounded animate-pulse"
                ></div>
                <div
                  class="h-4 w-12 sm:w-16 bg-gray-150 rounded-md animate-pulse"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseLayout>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import BaseLayout from "@/components/layout/BaseLayout.vue";
import {
  wechatLogin,
  isWechatEnvironment,
  isWechatDevtools,
  buildWechatAuthUrl,
  type WechatLoginResponse,
} from "@/api/wechat";
import { useAuthStore } from "@/stores/auth";
import { jwtService } from "@/services/jwt";
import { wechatService } from "@/services/wechatService";

type AuthStep =
  | "idle"
  | "checking"
  | "authorizing"
  | "processing"
  | "binding"
  | "completed"
  | "error";

const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();

const authStep = ref<AuthStep>("idle");
const authInProgress = ref(false);
const authError = ref<string>("");
const authSuccess = ref(false);
const debugInfo = ref<any>(null);
const isDevelopment = import.meta.env.DEV;

const wechatNickname = ref<string>("");
const userAvatar = ref<string>("");
const userName = ref<string>("");
const userStudentId = ref<string>("");

const isWechatEnv = ref(false);
const isWechatDevtoolsEnv = ref(false);

const addLog = (message: string, data?: any) => {
  if (isDevelopment) {
    console.log(`[WechatAuthorize] ${message}`, data);
    if (data) {
      debugInfo.value = {
        ...debugInfo.value,
        [new Date().toISOString()]: { message, data },
      };
    }
  }
};

const parseUserInfoFromJWT = () => {
  try {
    const accessToken = jwtService.getToken();
    if (accessToken) {
      const decodedToken = jwtService.parseToken(accessToken);
      if (decodedToken) {
        userName.value = decodedToken.name || decodedToken.username || "";
        userStudentId.value =
          decodedToken.student_id || decodedToken.studentId || "";
        addLog("JWT解析用户信息成功", {
          name: userName.value,
          studentId: userStudentId.value,
        });
      }
    }
  } catch (error) {
    addLog("JWT解析用户信息失败", error);
  }
};

const checkEnvironment = () => {
  isWechatEnv.value = isWechatEnvironment();
  isWechatDevtoolsEnv.value = isWechatDevtools();

  addLog("环境检测完成", {
    isWechatEnv: isWechatEnv.value,
    isWechatDevtools: isWechatDevtoolsEnv.value,
    userAgent: navigator.userAgent,
  });

  // 检查是否来自手动登出
  const isManualLogout = route.query.manual_logout === "true";

  if (!isWechatEnv.value && !isWechatDevtoolsEnv.value) {
    addLog("不在微信环境中，跳转到登录页面");
    redirectToLoginPage();
    return;
  }

  if (isManualLogout) {
    addLog("检测到用户手动登出，跳转到登录页面以提供账号选择");
    redirectToLoginPage();
    return;
  }
};

const handleAuthCallback = async () => {
  const code = route.query.code as string;
  const state = route.query.state as string;
  const error = route.query.error as string;

  if (error) {
    throw new Error(`微信授权失败: ${error}`);
  }

  if (!code) {
    await redirectToWechatAuth();
    return;
  }

  addLog("检测到授权码，开始处理登录", {
    code: code.substring(0, 10) + "...",
    state,
  });
  await processWechatLogin(code);
};

const redirectToWechatAuth = async () => {
  const appid =
    import.meta.env.VITE_WECHAT_APPID || import.meta.env.VITE_WECHAT_APP_ID;
  if (!appid) {
    throw new Error("微信 AppID 未配置，请检查环境变量 VITE_WECHAT_APPID");
  }

  authStep.value = "authorizing";

  const state = `auth_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
  const redirectUri = window.location.origin + window.location.pathname;
  const authUrl = buildWechatAuthUrl(
    appid,
    redirectUri,
    "snsapi_userinfo",
    state,
  );

  addLog("跳转到微信授权页面", { authUrl, redirectUri, state });

  window.location.href = authUrl;
};

const processWechatLogin = async (code: string) => {
  authStep.value = "processing";

  try {
    const loginResult: WechatLoginResponse = await wechatLogin(code);

    if (loginResult.nickname) {
      wechatNickname.value = loginResult.nickname;
    }
    if (loginResult.headimgurl) {
      userAvatar.value = loginResult.headimgurl;
    }

    addLog("微信登录成功", {
      openid: loginResult.openid?.substring(0, 8) + "***",
      nickname: loginResult.nickname,
      hasJwtAccessToken: !!loginResult.jwt_access_token,
      hasJwtRefreshToken: !!loginResult.jwt_refresh_token,
      username: loginResult.username,
    });

    if (!loginResult.openid) {
      throw new Error("未获取到微信 OpenID");
    }

    // 保存 openid 到 localStorage（无论是否已绑定都要保存）
    wechatService.saveOpenidToStorage(loginResult.openid);

    // 使用 JWT token 字段（jwt_access_token 和 jwt_refresh_token）
    if (loginResult.jwt_access_token && loginResult.jwt_refresh_token) {
      await performDirectLoginWithTokens({
        access: loginResult.jwt_access_token,
        refresh: loginResult.jwt_refresh_token,
      });
      return;
    }

    await redirectToLoginPage(loginResult.openid);
  } catch (error: any) {
    addLog("微信登录失败", error);
    await redirectToLoginPage();
  }
};

const performDirectLoginWithTokens = async (tokens: {
  access: string;
  refresh: string;
}) => {
  try {
    authStep.value = "completed";

    addLog("使用微信返回的 JWT tokens 登录", {
      hasAccess: !!tokens.access,
      hasRefresh: !!tokens.refresh,
    });

    jwtService.setTokens(tokens);
    parseUserInfoFromJWT();
    await authStore.fetchUser();

    authSuccess.value = true;

    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);

    addLog("授权完成，立即跳转");

    // 立即跳转，无延迟
    const redirectUrl = (route.query.redirect as string) || "/authorize";
    router.push(redirectUrl);
  } catch (error: any) {
    addLog("使用 tokens 登录失败", error);
    throw error;
  }
};

const redirectToLoginPage = async (openid?: string) => {
  const isManualLogout = route.query.manual_logout === "true";

  addLog("跳转到登录页面", {
    openid: openid ? openid.substring(0, 8) + "***" : "无openid",
    reason: isManualLogout
      ? "用户手动登出"
      : openid
        ? "需要绑定账号"
        : "授权失败或首次使用",
    isManualLogout,
  });

  const query: any = {
    redirect: (route.query.redirect as string) || "/authorize",
    from_wechat_auth: "true", // 标识来自微信授权页面，防止无限跳转
  };

  // 传递手动登出标识
  if (isManualLogout) {
    query["manual_logout"] = "true";
  }

  if (openid) {
    query["wechat_openid"] = openid;
  }

  router.push({
    path: "/login",
    query,
  });
};

const startAuthorization = async () => {
  try {
    authInProgress.value = true;
    authError.value = "";
    authStep.value = "checking";

    addLog("开始微信授权流程");

    checkEnvironment();

    // 如果不在微信环境中，checkEnvironment() 会直接返回，不需要继续执行
    if (!isWechatEnv.value && !isWechatDevtoolsEnv.value) {
      return;
    }

    await handleAuthCallback();
  } catch (error: any) {
    addLog("授权流程失败", error);
    authStep.value = "error";
    authError.value = error.message || "授权过程中发生错误";
  } finally {
    authInProgress.value = false;
  }
};

onMounted(() => {
  addLog("微信授权页面已加载", {
    url: window.location.href,
    query: route.query,
  });

  // 立即开始授权流程，无延迟
  startAuthorization();
});
</script>

<style scoped></style>
